import React from 'react';
import moment from 'moment';
import './DashboardPrintHeader.css';

/**
 * Header rendered at the top of every printed PDF page.
 * Styled after MainHeader so the exported PDF matches the app chrome.
 *
 * The `.dashboard-print-header` element is positioned as a running header
 * via CSS (position: fixed inside @media print) so it repeats on every
 * page of the generated PDF.
 */
function DashboardPrintHeader() {
  const now = moment();
  return (
    <div className="dashboard-print-header" id="dashboard-print-header">
      <div className="dashboard-print-header__logo">
        <img src="/s/style/img/RAA_Header.svg" alt="Room Alert ®" />
      </div>
      <div className="dashboard-print-header__meta">
        <div className="dashboard-print-header__date">
          {now.format('MMMM D, YYYY')}
        </div>
        <div className="dashboard-print-header__time">
          {now.format('h:mm A')}
        </div>
      </div>
    </div>
  );
}

export default DashboardPrintHeader;
